module.exports = __webpack_public_path__ + "img/vvv-loader.6f59db4a.png";